import axios from "axios";
import {
  SHARED_FORGOT_UPDATE_PASSWORD_FAIL,
  SHARED_FORGOT_UPDATE_PASSWORD_REQUEST,
  SHARED_FORGOT_UPDATE_PASSWORD_SUCCESS,
  SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_FAIL,
  SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_REQUEST,
  SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_SUCCESS,
  SHARED_LOGIN_FAIL,
  SHARED_LOGIN_REQUEST,
  SHARED_LOGIN_SUCCESS,
  SHARED_LOGOUT,
} from "../../types/shared/authTypes";
import api from "../mainAxios/mainAxios";
import {
  CHANGING_TOKEN_FAIL,
  CHANGING_TOKEN_REQUEST,
  CHANGING_TOKEN_SUCCESS,
} from "../../types/admin/authTypes";
import { themeAction } from "../admin/themeActions";

//SEND OTP FORGET PASSWORD
export const sendOtpForgetPasswordAction = (email) => async (dispatch) => {
  try {
    dispatch({
      type: SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/shared/auth/resendcode/get`,
      { email },
      config
    );
    dispatch({
      type: SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_SUCCESS,
      payload: data?.message,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Update password
export const updatePasswordAction = (formData) => async (dispatch) => {
  try {
    dispatch({
      type: SHARED_FORGOT_UPDATE_PASSWORD_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    // console.log(formData);
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URI}/api/shared/auth/updatepassword`,
      formData,
      config
    );
    // console.log(data);
    dispatch({
      type: SHARED_FORGOT_UPDATE_PASSWORD_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: SHARED_FORGOT_UPDATE_PASSWORD_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Shared Login
export const sharedLoginAction =
  (email, password, fcmToken) => async (dispatch) => {
    try {
      dispatch({
        type: SHARED_LOGIN_REQUEST,
      });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      // console.log(email, password);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/auth/signin`,
        { email, password, fcmToken },
        config
      );
      dispatch({
        type: SHARED_LOGIN_SUCCESS,
        payload: data?.data,
      });
      // console.log({ data });
      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(data?.data?.payload?.token, null, " ")
      );
      localStorage.setItem(
        "browserToken",
        JSON.stringify(data?.data?.payload?.browserToken, null, " ")
      );
      return data?.data?.payload;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: SHARED_LOGIN_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Shared Login
export const tokenLoginAction = (token) => async (dispatch) => {
  try {
    dispatch({
      type: SHARED_LOGIN_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    // console.log(email, password);
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/shared/token/login`,
      { token: "Bearer " + token },
      config
    );
    dispatch({
      type: SHARED_LOGIN_SUCCESS,
      payload: data?.data,
    });
    // console.log({ data });
    localStorage.setItem(
      "sharedUserInfo",
      JSON.stringify(data?.data?.payload?.token, null, " ")
    );
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: SHARED_LOGIN_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//loginUsingToken
export const changingTokenAction =
  (token, fcmToken, browserToken) => async (dispatch, getState) => {
    try {
      dispatch({
        type: CHANGING_TOKEN_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const body = {
        token: token.replace(/"/g, ""),
        fcmToken,
        browserToken,
      };
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/token/change`,
        body,
        config
      );
      // console.log(data);
      if (
        data?.data?.browserToken ===
          JSON.parse(localStorage.getItem("browserToken")) &&
        data?.data?.type === "logout-one-browser"
      ) {
        localStorage.clear();
        await dispatch({
          type: SHARED_LOGOUT,
        });

        dispatch(themeAction(true));
        window.location.replace("/login");
      } else {
        dispatch({
          type: CHANGING_TOKEN_SUCCESS,
          payload: data?.data,
        });
        dispatch({
          type: SHARED_LOGIN_SUCCESS,
          payload: data?.data,
        });
        localStorage.setItem(
          "sharedUserInfo",
          JSON.stringify(data?.data?.payload?.token, null, " ")
        );
      }
      return data?.data?.payload;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: CHANGING_TOKEN_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Logout
export const sharedLogoutAction = (formData) => async (dispatch) => {
  localStorage.removeItem("sharedUserInfo");
  localStorage.removeItem("personalUserInfo");
  localStorage.removeItem("activity");
  localStorage.removeItem("activity_date");
  localStorage.removeItem("report");
  localStorage.removeItem("report_date");
  localStorage.removeItem("timesheet");
  localStorage.removeItem("timesheet_date");
  localStorage.removeItem("report_payroll");
  localStorage.removeItem("report_payroll_date");
  localStorage.removeItem("UserInfo");
  await dispatch({
    type: SHARED_LOGOUT,
  });

  dispatch(themeAction(true));
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    // console.log(formData);
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/shared/auth/account/logout`,
      formData,
      config
    );
    localStorage.removeItem("browserToken");

    // console.log(data);
  } catch (error) {
    console.log(error);
  }

  // window.location.replace("/login");
};
